export default import.meta.ROLLDOWN_FILE_URL_UL4NuYua7t0D8RKNuTqZ$Q